// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
export var DisabledPropertyName = "Microsoft_ApplicationInsights_BypassAjaxInstrumentation";
export var SampleRate = "sampleRate";
export var ProcessLegacy = "ProcessLegacy";
export var HttpMethod = "http.method";
export var DEFAULT_BREEZE_ENDPOINT = "https://dc.services.visualstudio.com";
//# sourceMappingURL=Constants.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@microsoft/applicationinsights-common/dist-esm/Constants.js
// module id = ./node_modules/@microsoft/applicationinsights-common/dist-esm/Constants.js
// module chunks = vendor